import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../src/store/actions/actions'
// import ToggleFullscreen from '../common/ToggleFullscreen.web'
import HeaderRun from './Header.run'
import { IAppState } from '../../src/store/state.interface.web'
import ProfileDropdown from './HeaderProfile.web'
import { IUser } from '../../src/users/index.web'
import {withRouter, RouteComponentProps} from 'react-router'
import {Link} from 'react-router-dom'

interface IHeaderProps {
  actions?: any
  me: any
}

class Header extends Component<IHeaderProps & RouteComponentProps> {
  me: Partial<IUser> = {}

   componentDidMount() {
     HeaderRun()
    //  this.
  }

  toggleCollapsed = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    actions.toggleSetting('isCollapsed')
    this.resize()
  }

  toggleAside = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    actions.toggleSetting('asideToggled')
  }

  resize() {
    const evt = document.createEvent('UIEvents')
    evt.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(evt)
  }

  render() {
    const { firstName = '', lastName = '', title } = this.props.me
    const organizationName = this.props.me && this.props.me.organization ? this.props.me.organization.name : ''
    return (
      <header className="topnavbar-wrapper">
        <nav className="navbar topnavbar">
          <div className="  ml-2">
            <Link className="navbar-brand" to={this.props.me.isSuperUser ? '/practices' : '/patients'}>
            <img src={require('../../src/assets/images/Logo.png')} style={{maxWidth: 170}}></img>
            </Link>
          </div>
         { !this.props.me.isSuperUser? <ul className="navbar-nav flex-row  mt-2">
          <li className="nav-item" onClick={()=>{
              this.props.history.push(`/practices/${this.props.me.orgId}`)}}>
              <h5 className="pointerCursor" style={{ color: 'white' }}>{organizationName}</h5>
            </li>
          </ul> : null}

          <ul className="navbar-nav flex-row">
            <li className="nav-item">
              <ProfileDropdown firstName={firstName} lastName={lastName} title={title}/>
            </li>
          </ul>
        </nav>
      </header>
    )
  }
}

const mapStateToProps = (state: IAppState) => (
  {
    settings: state.settings,
    me: state.login.user
  })

const mapDispatchToProps = (
  dispatch: (arg0: { type: string; name: any }) => void
) => ({
  toggleSetting: (payload: string) => dispatch(actions.toggleSetting(payload))
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Header))
